import React, { useState } from 'react';
import styled from 'styled-components';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronDown, faChevronUp } from '@fortawesome/free-solid-svg-icons';

const PanelContainer = styled.div`
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  margin-bottom: 1rem;
  overflow: hidden;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
`;

const PanelHeader = styled.div`
  padding: 1rem;
  background-color: #fff;
  cursor: pointer;
  display: flex;
  justify-content: space-between;
  align-items: center;
  transition: background-color 0.3s ease;

  &:hover {
    background-color: #f8f8f8;
  }
`;

const Title = styled.h3`
  margin: 0;
  color: #316C6E;
  font-size: 1.1rem;
  flex: 1;
`;

const IconWrapper = styled.span`
  color: #316C6E;
  margin-left: 1rem;
  transition: transform 0.3s ease;
`;

const ContentWrapper = styled.div`
  padding: ${props => props.isOpen ? '1rem' : '0 1rem'};
  max-height: ${props => props.isOpen ? '500px' : '0'};
  opacity: ${props => props.isOpen ? '1' : '0'};
  transition: all 0.3s ease-in-out;
  background-color: #fff;
`;

const Content = styled.div`
  color: #666;
  line-height: 1.6;
`;

const FAQPanel = ({ title, content }) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <PanelContainer>
      <PanelHeader onClick={() => setIsOpen(!isOpen)}>
        <Title>{title}</Title>
        <IconWrapper>
          <FontAwesomeIcon icon={isOpen ? faChevronUp : faChevronDown} />
        </IconWrapper>
      </PanelHeader>
      <ContentWrapper isOpen={isOpen}>
        <Content>{content}</Content>
      </ContentWrapper>
    </PanelContainer>
  );
};

export default FAQPanel; 